// HOME
import { useNavigate, Link, useOutletContext } from 'react-router-dom';
import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import Carousel from "react-bootstrap/Carousel";
// funciones
import { slugify, estrellas } from "../funcionesDatos/Textos";



function CardVendedor({vendedor, resuVendedor}){
    

    return(
    <Link to={`/${vendedor.username}`} className="card border-0 shadow-sm mb-3 text-decoration-none text-reset d-block" style={{ cursor: 'pointer' }}>
        <div className="card-body">
            {/* FOTO Y NOMBRE */}
            <div className="d-flex align-items-center gap-3">
                {/* IMAGEN ICONO DEL USUARIO */}
                <div className="position-relative" style={{ width: 50, height: 50, flexShrink: 0 }}>
                {/* Anillo degradado */}
                <div style={{ width: 50, height: 50, borderRadius: "50%", background: "linear-gradient(135deg, #6366f1, #2563eb, #06b6d4)", padding: 2.5 }}>
                    <div className="rounded-circle d-flex justify-content-center align-items-center overflow-hidden" style={{ width: "100%", height: "100%", background: "var(--color-bg-card, #fff)" }}>
                    {vendedor?.avatar ?
                    <img src={vendedor.avatar} alt="Vendedor" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
                    : <i className="bi bi-person" style={{ fontSize: 22 }}></i> }
                    </div>
                </div>

                {vendedor?.verificacionIdentidad?.estado === "aprobado" && (
                    <img
                        src="https://zervicy.s3.us-east-1.amazonaws.com/imagenes/iconos/autenticado.svg"
                        alt="Verificado"
                        style={{ position: "absolute", top: -3, left: -3, width: 18, height: 18, zIndex: 2, filter: "brightness(0) invert(1) opacity(0.9)" }}
                    />
                )}
                </div>
                {/* INFO DEL VENEDOR */}
                <div>
                <div className="fw-semibold d-flex align-items-center gap-2 flex-wrap">
                    <span>Vendedor</span>
                    {vendedor?.perfilProfesional?.completo === true && (
                    <span
                        className="badge rounded-pill"
                        style={{ backgroundColor: "var(--azul-info-fondo)", color: "var(--azul-logo-claro)", border: "1px solid var(--azul-cielo)", fontWeight: 600 }}
                    >
                        <i className="bi bi-patch-check-fill me-1"></i>
                        Profesional
                    </span>
                    )}
                    {vendedor?.verificacionIdentidad?.estado === "aprobado" && (
                    <span
                        className="badge rounded-pill"
                        style={{ backgroundColor: "var(--verde-fondo-esmeralda)", color: "var(--verde-esmeralda-texto)", border: "1px solid var(--verde-esmeralda-borde)", fontWeight: 600 }}
                    >
                        <i className="bi bi-patch-check-fill me-1"></i>
                        Verificado
                    </span>
                    )}
                </div>
                <small className="text-muted">{vendedor.username}</small>
                </div>
            </div>

            {/* RESEÑAS, CIUDAD Y CONTACTAR */}
            <div className="mt-2">
                {/* RESEÑAS */}
                <div className="d-flex align-items-center flex-wrap gap-2">
                <div className="d-flex align-items-center flex-wrap gap-2">
                    {(() => {
                    if (resuVendedor.cantidad <= 0) { return <span className="text-muted">Sin reseñas aún</span>; }

                    return (
                        <>
                        <span className="text-primary" style={{ letterSpacing: 1 }}>
                            {estrellas(resuVendedor?.cantidadEstrellas)}
                        </span>
                        <span className="fw-semibold">{resuVendedor?.valoracionFinal}</span>
                        <small className="text-muted">({resuVendedor?.cantidad} reseñas)</small>
                        </>
                    );
                    })()}
                </div>
                </div>

                {/* CIUDAD */}
                <div className="mt-1">
                <small className="text-muted">
                    <i className="bi bi-geo-alt me-1"></i>
                    {vendedor.ciudad + ", " + vendedor.pais}
                </small>
                </div>

                {/* VER PERFIL */}
                <div className="mt-2 text-end">
                    <small style={{ color: "var(--gris-suave, #9ca3af)", fontWeight: 600 }}>Ver perfil →</small>
                </div>

                {/* CONTACTAR */}
                {/* <button
                type="button"
                className="btn btn-secondary w-100 mt-3"
                onClick={() => { Swal.fire({ icon: "info", title: "Contactar (próximo paso)", text: "Aquí abriremos un chat sencillo para resolver preguntas antes de ordenar." }); }}
                >
                Contactar
                </button> */}
            </div>
        </div>
    </Link>
    );
}

export default CardVendedor;